const listeners = [];
let running = false;

const polyfillEventMsDelay = 66; // 15 FPS

function runListeners() {
  listeners.forEach(listener => listener.fn.call(listener.scope));

  running = false;
}

/**
 * Listener para o evento de resize original.
 * Dispara o evento de resize otimizado.
 */
function resize() {
  if (!running) {
    running = true;

    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(runListeners);
    } else {
      setTimeout(runListeners, polyfillEventMsDelay);
    }
  }
}

function addListener(fn, scope) {
  listeners.push({
    fn,
    scope,
  });
}

function removeListener(fn, scope) {
  const index = listeners.findIndex(listener => listener.fn === fn
    && listener.scope === scope);
  if (index < 0) {
    throw new Error('Ouvinte não existente ao tentar remover.');
  }
  listeners.splice(index, 1);
}

/**
 * Wrapper para evento de Resize do navegador com tratamento para
 * otimização da execução.
 */
const optimizedResizeEvent = {
  on(listener, scope = null) {
    if (!listeners.length) {
      window.addEventListener('resize', resize);
    }
    addListener(listener, scope);
  },
  off(listener, scope = null) {
    removeListener(listener, scope);
    if (!listeners.length) {
      window.removeEventListener('resize', resize);
    }
  },
};

export default optimizedResizeEvent;
